<template>
  <div class="alb2">
    <!-- ═══ MODO LISTADO ═══ -->
    <div v-if="modoAlbaran" class="alb2__main">

      <!-- Toolbar superior -->
      <div class="alb2__toolbar">
        <div class="alb2__toolbar-left">
          <button class="alb2__btn alb2__btn--outline" @click="editarPrecios()">
            <i class="fa-solid fa-tags"></i> Precios Sku
          </button>
          <button class="alb2__btn alb2__btn--warning" @click="abrirSinPrecio()">
            <i class="fa-solid fa-circle-exclamation"></i> Sin precio
            <span v-if="countSinPrecio > 0" class="alb2__count-badge">{{ countSinPrecio }}</span>
          </button>
        </div>
        <button class="alb2__btn-fab" @click="modoAlbaran = false" v-b-tooltip.hover.v-success title="Crear nuevo">
          <i class="fa-solid fa-plus"></i>
        </button>
        <div class="alb2__toolbar-right"></div>
      </div>

      <!-- Calendario + Facturar -->
      <div class="alb2__calendar-section">
        <b-row>
          <b-col cols="6">
            <div class="alb2__calendar-wrap">
              <date-range-picker
                :ranges="ranges"
                :locale-data="locale"
                v-model="dateRange"
                :opens="'inline'"
                class="alb2__datepicker"
              />
            </div>
          </b-col>
          <b-col cols="6" class="d-flex flex-column justify-content-center" style="gap: 14px">
            <button class="alb2__facturar-btn alb2__facturar-btn--0" @click="facturar(true)">
              <div class="alb2__facturar-main">
                <i class="fa-solid fa-file-invoice"></i>
                <span>Facturar 0%</span>
              </div>
              <div class="alb2__facturar-meta" v-if="ultimaFecha0 != '' || total0 != ''">
                <span v-if="ultimaFecha0 != ''" class="alb2__facturar-date">
                  <i class="fa-regular fa-calendar"></i> {{ ultimaFecha0 }}
                </span>
                <span v-if="total0 != ''" class="alb2__facturar-total">{{ total0 }}</span>
              </div>
            </button>
            <button class="alb2__facturar-btn alb2__facturar-btn--21" @click="facturar(false)">
              <div class="alb2__facturar-main">
                <i class="fa-solid fa-file-invoice-dollar"></i>
                <span>Facturar 21%</span>
              </div>
              <div class="alb2__facturar-meta" v-if="ultimaFecha21 != '' || total21 != ''">
                <span v-if="ultimaFecha21 != ''" class="alb2__facturar-date">
                  <i class="fa-regular fa-calendar"></i> {{ ultimaFecha21 }}
                </span>
                <span v-if="total21 != ''" class="alb2__facturar-total">{{ total21 }}</span>
              </div>
            </button>
          </b-col>
        </b-row>
      </div>

      <!-- Secciones ocultas (v-if="false") preservadas -->
      <div v-if="false">
        <b-row>
          <div class="col-3">
            <span>Pendiente</span>
            <b-form-checkbox v-model="pedienteCheck" name="check-button" switch inline>
              <span>Facturados</span>
            </b-form-checkbox>
          </div>
          <div class="col-2">
            <div class="d-flex align-items-center mb-1">
              <span>Desde</span>
              <flat-pickr v-model="fechaDesdeSelect" class="form-control" />
              <button class="btn btn-default" @click="fechaDesdeSelect = ''"><i class="fa-solid fa-eraser"></i></button>
            </div>
          </div>
          <div class="col-2">
            <div class="d-flex align-items-center mb-1">
              <span>Hasta</span>
              <flat-pickr v-model="fechaHastaSelect" class="form-control" />
              <button class="btn btn-default" @click="fechaHastaSelect = ''"><i class="fa-solid fa-eraser"></i></button>
            </div>
          </div>
          <div class="col-2">
            <b-button variant="outline-primary" class="btn-icon rounded-circle" @click="seleccionarTodos()">
              <i class="fa-solid fa-check"></i></b-button>
            <b-button variant="outline-warning" class="btn-icon rounded-circle" @click="limpiarSeleccionados()">
              <i class="fa-solid fa-eraser"></i></b-button>
          </div>
          <div class="col-3" v-if="!agruparCheck">
            <span v-if="cantidadCheck > 0">( <b>{{cantidadCheck}}</b> ) TOTAL: <b>{{totalCheck}} &euro;</b></span>
            <b-button variant="outline-success" class="btn-icon" @click="facturarProductos()"><i class="fa-solid fa-file-invoice-dollar"></i></b-button>
            <b-button variant="outline-primary" class="btn-icon" @click="pedirCodigo()"><i class="fa-solid fa-pen-to-square"></i></b-button>
            <b-button variant="outline-danger" class="btn-icon" @click="borrarButtonClick()"><i class="fa-solid fa-trash"></i></b-button>
          </div>
        </b-row>
        <b-row>
          <div class="col-12">
            <b-form-checkbox id="checkbox-1" v-model="agruparCheck" name="checkbox-1">Agrupar</b-form-checkbox>
          </div>
        </b-row>
      </div>

      <!-- Buscador -->
      <div class="alb2__search">
        <i class="fa-solid fa-magnifying-glass alb2__search-icon"></i>
        <input type="text" class="alb2__search-input" placeholder="Buscar por SKU..." v-model="buscar" />
      </div>

      <!-- Tabla principal -->
      <div class="alb2__table-card">
        <b-table
          :items="articulosBusqueda"
          :fields="columnasTable"
          class="alb2__table"
          no-border-collapse
          sort-icon-left
          @sort-changed="sortChanged"
          ref="table"
          hover
          thead-class="alb2__thead"
        >
          <template #cell(check)="data">
            <span @click="itemCheck()">
              <b-form-checkbox v-model="data.item.check"></b-form-checkbox>
            </span>
          </template>

          <template #cell(sku)="data">
            <span class="alb2__sku" @click="rowClick(data.item)">{{ data.item.sku }}</span>
          </template>

          <template #cell(cantidad)="data">
            <span class="alb2__cantidad" v-if="!data.item.editando" @click="editandoCantidad(data.item)">
              {{ data.item.cantidad }}
            </span>
            <div v-if="data.item.editando" class="alb2__cantidad-edit">
              <input type="text" v-model="data.item.cantidad" class="alb2__cantidad-input">
              <button class="alb2__cantidad-save" @click="guardarCantidad(data.item)">
                <i class="fa-solid fa-floppy-disk"></i>
              </button>
            </div>
          </template>

          <template #cell(img)="data">
            <img v-if="data.item.image" :src="data.item.image" class="alb2__img" alt="">
          </template>

          <template #cell(factura)="data">
            <span v-if="data.item.factura" class="alb2__badge alb2__badge--facturado">{{ data.item.factura }}</span>
            <span v-else class="alb2__badge alb2__badge--pendiente">Pendiente</span>
          </template>
        </b-table>
        <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10"></div>
      </div>

      <!-- Modal agregar -->
      <b-modal id="modal-add" :title="tituloModal" centered size="xl" hide-footer modal-class="alb2__modal">
        <div v-if="false">
          <b-row class="match-height">
            <b-col cols="7">
              <b-form-group label="Sku"><v-select v-model="inputSku" label="sku" :options="articulos" /></b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group label="Cantidad"><b-form-input placeholder="cantidad" v-model="inputCantidad" type="number" @wheel.prevent /></b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group label="Fecha">
                <b-form-datepicker v-model="inputFecha" class="mb-2" today-button placeholder="fecha"
                  :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }" locale="es"></b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group v-if="inputSku != null && inputSku.shopify_product_id == -1" label="Titulo">
                <b-form-input placeholder="titulo" v-model="inputTitulo" />
              </b-form-group>
            </b-col>
          </b-row>
          <div class="text-center" style="height: 300px">
            <img v-if="inputSku != null" :src="inputSku.image" style="max-height: 300px" alt="">
          </div>
        </div>
        <div v-else>
          <b-table :items="articulosAddMore" :fields="columnasAddMore" class="alb2__table alb2__table--add"
            no-border-collapse sort-icon-left ref="tableAddMore" hover thead-class="alb2__thead">
            <template #cell(_img)="data">
              <img v-if="data.item.sku != null && data.item.sku.image" :src="data.item.sku.image" class="alb2__img alb2__img--lg" alt="">
            </template>
            <template #cell(_sku)="data">
              <v-select v-model="data.item.sku" label="sku" :options="articulos" />
              <b-form-input class="mt-50" v-if="data.item.sku != null && data.item.sku.shopify_product_id == -1"
                placeholder="titulo" v-model="data.item.titulo" />
            </template>
            <template #cell(_cantidad)="data">
              <b-form-input placeholder="cantidad" v-model="data.item.cantidad" type="number" @wheel.prevent />
            </template>
            <template #cell(_fecha)="data">
              <b-form-datepicker v-model="data.item.fecha" class="mb-0" today-button placeholder="fecha"
                :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }" locale="es"></b-form-datepicker>
            </template>
            <template #cell(_opt)="data">
              <button class="alb2__btn-icon alb2__btn-icon--danger" @click="deleteLineAddMore(data.index)">
                <i class="fa-solid fa-minus"></i>
              </button>
            </template>
          </b-table>
          <div class="alb2__add-actions">
            <button class="alb2__btn alb2__btn--primary" @click="addMore()">
              <i class="fa-solid fa-plus"></i> Agregar mas
            </button>
          </div>
        </div>
        <div class="alb2__add-actions" style="margin-top: 16px">
          <button class="alb2__btn alb2__btn--success" @click="guardarPendiente()">
            <i class="fa-solid fa-floppy-disk"></i> {{ textBotonGuardar }}
          </button>
        </div>
      </b-modal>

      <!-- Modal productos sin precio -->
      <b-modal id="modal-sin-precio" title="Productos sin precio" centered size="lg" hide-footer modal-class="alb2__modal">
        <div v-if="sinPrecioLista.length === 0" class="alb2__sp-empty">
          <i class="fa-solid fa-circle-check"></i>
          <p>Todos los productos pendientes tienen precio.</p>
        </div>
        <div v-else>
          <p class="alb2__sp-hint">
            Introduce el precio de <b>confección (€ por unidad)</b>. Se creará el precio del SKU base y se aplicará a los albaranes pendientes.
          </p>
          <div v-for="grupo in sinPrecioLista" :key="grupo.skuBase" class="alb2__sp-row">
            <img v-if="grupo.image" :src="grupo.image" class="alb2__img alb2__img--lg" alt="">
            <div v-else class="alb2__sp-noimg"><i class="fa-regular fa-image"></i></div>
            <div class="alb2__sp-info">
              <div class="alb2__sp-sku">{{ grupo.skuBase }}</div>
              <div class="alb2__sp-meta">{{ grupo.lineas }} albarán(es) · {{ grupo.unidades }} uds</div>
            </div>
            <button class="alb2__btn alb2__btn--primary" @click="abrirFormPrecio(grupo)">
              <i class="fa-solid fa-tag"></i> Agregar precio
            </button>
          </div>
        </div>
      </b-modal>

      <!-- Modal formulario completo de precio (igual que Precios Sku) -->
      <b-modal id="modal-precio-form" title="Agregar precio" centered size="lg" hide-footer modal-class="alb2__modal">
        <b-row class="match-height justify-content-center">
          <!--Nombre-->
          <b-col cols="6">
            <b-form-group label="Nombre" label-for="spNombre">
              <b-form-input id="spNombre" placeholder="nombre" v-model="spNombre" type="text" />
            </b-form-group>
          </b-col>
          <!--Sku-->
          <b-col cols="5">
            <b-form-group label="Sku" label-for="spSku">
              <b-form-input id="spSku" placeholder="codigo" v-model="spSku" type="text" />
            </b-form-group>
          </b-col>
          <!--Lupa-->
          <b-col cols="1">
            <div style="text-align: center; margin-top: 22px">
              <b-button :variant="spVariantSearch" class="btn-icon" @click="buscarSkuPrecio()">
                <i class="fa-solid fa-magnifying-glass"></i>
              </b-button>
            </div>
          </b-col>
          <!--Confeccion-->
          <b-col cols="3">
            <b-form-group label="Confeccion €" label-for="spConfeccion">
              <b-form-input id="spConfeccion" placeholder="confeccion" v-model="spConfeccion" type="text" :readonly="!spAutoManual" />
            </b-form-group>
          </b-col>
          <!--Ubrique-->
          <b-col cols="3">
            <b-form-group class="title-bold" label="Ubrique €" label-for="spUbrique">
              <b-form-input id="spUbrique" placeholder="ubrique" v-model="spUbrique" type="text" />
            </b-form-group>
          </b-col>
          <!--Materiales-->
          <b-col cols="3">
            <b-form-group class="title-bold" label="Materias €" label-for="spMateriales">
              <b-form-input id="spMateriales" placeholder="materias" v-model="spMateriales" type="text" />
            </b-form-group>
          </b-col>
          <!--Total-->
          <b-col cols="3">
            <b-form-group label="Total €" label-for="spTotal">
              <b-form-input id="spTotal" placeholder="total" v-model="spTotal" type="text" readonly />
            </b-form-group>
          </b-col>
          <!--Packaging-->
          <b-col cols="3">
            <b-form-group class="title-bold" label="Packaging €" label-for="spPackaging">
              <b-form-input id="spPackaging" placeholder="packaging" v-model="spPackaging" type="text" />
            </b-form-group>
          </b-col>
          <!--Shipping-->
          <b-col cols="3">
            <b-form-group class="title-bold" label="Shipping €" label-for="spShipping">
              <b-form-input id="spShipping" placeholder="shipping" v-model="spShipping" type="text" />
            </b-form-group>
          </b-col>
          <!--Rrp £-->
          <b-col cols="3">
            <b-form-group class="title-bold" label="Rrp £" label-for="spRrp">
              <b-form-input id="spRrp" placeholder="precio £" v-model="spRrp" type="text" />
            </b-form-group>
          </b-col>
          <!--Rrp €-->
          <b-col cols="3">
            <b-form-group label="Rrp €" label-for="spRrpE">
              <b-form-input id="spRrpE" placeholder="precio €" v-model="spRrpE" type="text" readonly />
            </b-form-group>
          </b-col>
          <!--Roas-->
          <b-col cols="3">
            <b-form-group label="Roas %" label-for="spRoas">
              <b-form-input id="spRoas" placeholder="roas %" v-model="spRoas" type="text" readonly />
            </b-form-group>
          </b-col>
          <!--Auto / Manual-->
          <b-col cols="3">
            <span style="margin-top: 27px; font-size: 14px; font-weight: lighter;">Auto</span>
            <b-form-checkbox style="margin-left: 50px; margin-top: -22px" v-model="spAutoManual" name="check-button" class="check-button-label" switch inline>
              Manual
            </b-form-checkbox>
          </b-col>
          <!--Multiplicador-->
          <b-col cols="3">
            <b-form-group v-if="!spAutoManual" class="input-auto" label="Multiplicador" label-for="spMultiplicador">
              <b-form-input id="spMultiplicador" placeholder="multiplicador" v-model="spMultiplicador" type="text" />
            </b-form-group>
          </b-col>
          <!--Exchange-->
          <b-col cols="3">
            <b-form-group class="input-auto" :label="'Exchange: ' + exchangeLibraEuro" label-for="spExchange">
              <b-form-input id="spExchange" placeholder="exchange" v-model="spExchange" type="text" />
            </b-form-group>
          </b-col>
        </b-row>

        <div style="text-align: center; margin-top: 10px">
          <b-button variant="outline-success" class="btn-icon" :disabled="spGuardando" @click="guardarPrecioForm()">
            Guardar Sku
          </b-button>
        </div>
      </b-modal>
    </div>

    <!-- ═══ MODO AGREGAR ═══ -->
    <div v-else class="alb2__main">
      <div class="alb2__toolbar">
        <button class="alb2__btn alb2__btn--secondary" @click="modoAlbaran = true">
          <i class="fa-solid fa-chevron-left"></i> Volver
        </button>
        <div class="alb2__toolbar-title">
          <i class="fa-solid fa-plus-circle"></i> Nuevo Albaran
        </div>
        <div></div>
      </div>

      <div class="alb2__table-card">
        <b-table :items="articulosAddMore" :fields="columnasAddMore" class="alb2__table alb2__table--add"
          no-border-collapse sort-icon-left ref="tableAddMore" hover thead-class="alb2__thead">
          <template #cell(_img)="data">
            <img v-if="data.item.sku != null && data.item.sku.image" :src="data.item.sku.image" class="alb2__img alb2__img--lg" alt="">
          </template>
          <template #cell(_sku)="data">
            <v-select v-model="data.item.sku" label="sku" :options="articulos" />
            <b-form-input class="mt-50" v-if="data.item.sku != null && data.item.sku.shopify_product_id == -1"
              placeholder="titulo" v-model="data.item.titulo" />
          </template>
          <template #cell(_cantidad)="data">
            <b-form-input placeholder="cantidad" v-model="data.item.cantidad" type="number" @wheel.prevent />
          </template>
          <template #cell(_fecha)="data">
            <b-form-datepicker v-model="data.item.fecha" class="mb-0" today-button placeholder="fecha"
              :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }" locale="es"></b-form-datepicker>
          </template>
          <template #cell(_opt)="data">
            <button class="alb2__btn-icon alb2__btn-icon--danger" @click="deleteLineAddMore(data.index)">
              <i class="fa-solid fa-minus"></i>
            </button>
          </template>
        </b-table>
        <div class="alb2__add-footer">
          <button class="alb2__btn alb2__btn--primary" @click="addMore()">
            <i class="fa-solid fa-plus"></i> Agregar mas
          </button>
        </div>
      </div>

      <div class="alb2__bottom-bar">
        <button class="alb2__btn alb2__btn--danger-outline" @click="limpiarAdd()">
          <i class="fa-solid fa-eraser"></i> Limpiar
        </button>
        <button class="alb2__btn alb2__btn--success" @click="guardarPendiente()">
          <i class="fa-solid fa-floppy-disk"></i> {{ textBotonGuardar }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@axios'
/*import VueApexCharts from 'vue-apexcharts'*/
import { BTable , BFormCheckbox, BFormInput, BFormGroup, BModal, BCardText, BCardBody, BCard, BRow, BCol} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import { $themeColors } from '@themeConfig'
import { useTimeout } from '@vueuse/shared'
import vSelect from 'vue-select'
import { forEach } from 'postcss-rtl/lib/affected-props'
import flatPickr from 'vue-flatpickr-component'

import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import moment from "moment";

  export default {
    components: {
        BCardCode,
        BFormCheckbox,
        BTable,
        BFormInput,
        BFormGroup,
        BCardText,
        BCardBody,
        BCard,
        BRow,
        BCol,
        vSelect,
        flatPickr,
        DateRangePicker
    },
    data () {
      return {
        dateRange: {
        startDate: moment().subtract(7, "days")._d,
        endDate:moment().subtract(1, "days")._d,
      },
      locale: {
        format: "dd/mm/yyyy",
        separator: " - ",
        applyLabel: "Buscar",
        cancelLabel: "Cancelar",
        fromLabel: "Desde",
        toLabel: "Hasta",
        customRangeLabel: "Personalizado",
        daysOfWeek: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
        monthNames: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre",
        ],
        firstDay: 1,
      },
      ranges: {
        "Últimos 7 días": [moment().subtract(7, "days")._d,moment().subtract(1, "days")._d,],
        "Últimos 30 días": [moment().subtract(30, "days")._d,moment().subtract(1, "days")._d,],
        "Últimos 60 días": [moment().subtract(60, "days")._d,moment().subtract(1, "days")._d,],
        "Últimos 90 días": [moment().subtract(90, "days")._d,moment().subtract(1, "days")._d,],
        "Este mes": [moment().startOf("month")._d, moment().endOf("month")._d],
      },
        columnasAll: [
        /*{
          key: "check",
          label: "",
          sortable: false,
          thStyle: { width: "1%" },
        },*/
        {
          key: "img",
          label: "",
          sortable: false,
          thStyle: { width: "10%" },
        },
        {
          key: "cantidad",
          label: "Cantidad",
          sortable: true,
          thStyle: { width: "5%" },
        },
        {
          key: "sku",
          label: "SKU",
          sortable: true,
          thStyle: { width: "20%" },
        },{
          key: "total",
          label: "Precio",
          sortable: true,
          thStyle: { width: "10%" },
        },{
          key: "fechaTerminado",
          label: "Fecha",
          sortable: true,
          thStyle: { width: "10%" },
        },{
          key: "factura",
          label: "Factura",
          sortable: true,
        }],
        articulos: [],
        anyo: 2022,
        buscar: "",
        countItemView: 30,
        nextScrollItemView: 20,
        defaultItemView: 30,
        watching: true,
        lastSort: null,
        anyoSelect: {nombre: "Todos", value: 'Todos', active: true},
        articulosBusqueda: [],
        columnasTable: [],
        listadoAnyos:[
          {nombre: "Todos", value: 'Todos', active: true},
          {nombre: "2024", value: 2024, active: true},
          {nombre: "2023", value: 2023, active: true},          
          ],
        pedienteCheck: false,
        inputSku: "",
        inputCantidad: "",
        textBotonGuardar: "Guardar",
        tituloModal: "Añadir producto",
        inputFecha: "",
        inputTitulo: "",
        listadoPendiente: [],
        articulosSku: [],
        totalCheck: 0,
        cantidadCheck: 0,
        esperandoCalcular: true,
        fechaDesdeSelect: '',
        fechaHastaSelect: '',
        agruparCheck: false,
        agregarMultiple: 1,
        columnasAddMore: [
        {
          key: "_img",
          label: "",
          sortable: false,
          thStyle: { width: "5%" },
        },
        {
          key: "_sku",
          label: "SKU",
          sortable: true,
          thStyle: { width: "20%" },
        },
        {
          key: "_cantidad",
          label: "Cantidad",
          sortable: true,
          thStyle: { width: "5%" },
        },
        {
          key: "_fecha",
          label: "Fecha",
          sortable: true,
          thStyle: { width: "10%" },
        },
        {
          key: "_opt",
          label: "",
          sortable: true,
          thStyle: { width: "5%" },
        }],
        articulosAddMore: [
          { image: '',
            sku: '',
            cantidad: '',
            fecha: ''
          }
        ],
        modoAlbaran: true,
        ordersDate: [],
        pendientesParaFacturar:[],
        to21: false,
        listadoTrackingsUsados:[],
        ultimaFecha0: "",
        ultimaFecha21: "",
        total0: 0,
        total21: 0,
        sinPrecioLista: [],
        // Formulario de precio (sin precio)
        spNombre: '',
        spSku: '',
        spConfeccion: 0,
        spUbrique: 0,
        spMateriales: 0,
        spPackaging: 0,
        spShipping: 0,
        spRrp: 0,
        spRrpE: 0,
        spRoas: 0,
        spHsCode: '',
        spTotal: 0,
        spMultiplicador: 0.155,
        spExchange: 1.16,
        spAutoManual: false,
        spVariantSearch: 'outline-primary',
        spGuardando: false,
        spGrupoActual: null,
        exchangeLibraEuro: 1.16,
        listadoProductos: [],
      }
    },
    computed: {
      countSinPrecio(){
        const skus = new Set();
        this.listadoPendiente.forEach(item => {
          if(item.finalizado)
            return;
          if(item.total !== undefined && item.total !== null && item.total !== '')
            return;
          if(this.esSinPrecioExcluido(item.sku))
            return;
          skus.add(this.calcularSkuCortado(item.sku));
        });
        return skus.size;
      }
    },
    methods:{
      loadItems(){
        this.cargarColumnas();

        axios.post("/uso", {seccion:"albaran-auto"});

        axios.get("/shopify/products")
          .then(response => response.data)
          .then(res => { this.listadoProductos = res; })
          .catch(() => {});

        axios.get("/shopify/exchange/GBP")
          .then(response => response.data)
          .then(res => { this.exchangeLibraEuro = res.rates.EUR; })
          .catch(() => {});



        /*async obtenerTracking() {
        try {
          const response = await axios.post(`/finanzas/tracking/info`, { fechaMasBaja: this.fechaMasBaja });
          this.responseTracking = response;
          this.datosTracking = response.data;

          this.datosTracking.sort((a, b) => new Date(a.confirmation_date) - new Date(b.confirmation_date));

        } catch (err) {
          console.error("Error al obtener tracking:", err);
        }
      },
      */

        //const requestArticulos = axios.get("/articulos/variants").then(response => response.data);
        const requestPendiente = axios.get("/finanzas/pendiente/facturar").then(response => response.data);
        const requestArticulosPrecios = axios.get("/finanzas/articulos").then(response => response.data);
        const fetchArticulosShopify = axios.get("/articulos/shopify").then(response => response.data);
        const fetchFacturaTracking = axios.get("/finanzas/factura/tracking").then(response => response.data);

        const start = new Date(this.dateRange.startDate);
        start.setHours(0, 0, 0, 0); // 00:00:00.000

        const end = new Date(this.dateRange.endDate);
        end.setHours(23, 59, 59, 999); // 23:59:59.999

        const requestTrackings = axios.get("/finanzas/tracking/dates", {
            params: {
              fechaInicio: start.toISOString(),
              fechaFin: end.toISOString()
            }
        }).then(response => response.data);

 

        Promise.all([requestPendiente, requestArticulosPrecios, fetchArticulosShopify, requestTrackings, fetchFacturaTracking])
        .then(([resPendiente, resArticulosPrecios, resArticulosShopify, resTracking, resFacturaTracking]) => {     

          this.ordersDate = resTracking;        

          this.listadoTrackingsUsados = resFacturaTracking.sort((a, b) => new Date(b.fechaTracking) - new Date(a.fechaTracking));
          this.ultimaFecha0 = resFacturaTracking.filter(item => item.country_sent !== 'ES' ).length > 0 ? resFacturaTracking.filter(item => item.country_sent !== 'ES')[0].fechaTracking : "";
          this.ultimaFecha0 = this.ultimaFecha0 ? this.ultimaFecha0.split('T')[0] : "";
          this.ultimaFecha21 = resFacturaTracking.filter(item => item.country_sent === 'ES' ).length > 0 ? resFacturaTracking.filter(item => item.country_sent === 'ES')[0].fechaTracking : "";
          this.ultimaFecha21 = this.ultimaFecha21 ? this.ultimaFecha21.split('T')[0] : "";


            this.articulos = Array.from(
              new Map(
                resArticulosShopify.flatMap(item =>
                  item.variants
                    .filter(variant => variant.sku)
                    .map(variant => {
                      const image = item.images.find(img => img.id === variant.image_id) || {};
                      return {
                        sku: variant.sku,
                        precio: parseFloat(variant.price),
                        image: image.src || '',
                        shopify_product_id: variant.id
                      };
                    })
                ).map(articulo => [articulo.sku, articulo])
              ).values()
            );

            //this.articulos hay que quitar los articulos que solo tengan precio de ubrique

            //this.articulosSku

            this.articulosSku = resArticulosPrecios;

            this.articulos = this.articulos.filter(articulo => {
              let skuCortado = articulo.sku.replace(/-[^-]+$/, "");
              const articuloEncontrado = this.articulosSku.find(item => item.sku === skuCortado);

              return articuloEncontrado && Number(articuloEncontrado.confeccion) !== 0;
            });


            this.articulos = this.articulos.filter(x => !x.sku.includes("RPET-COMMUTER-BACKPACK-13"));

            this.articulos.push({ sku: "CLOTH-BAG-S", image: "https://cdn.shopify.com/s/files/1/0653/3919/files/Bolsa-tela-Harber-London.heic?v=1701255212", shopify_product_id: 999999 });
            this.articulos.push({ sku: "CLOTH-BAG-M", image: "https://cdn.shopify.com/s/files/1/0653/3919/files/Bolsa-tela-Harber-London.heic?v=1701255212", shopify_product_id: 999998 });
            this.articulos.push({ sku: "CLOTH-BAG-L", image: "https://cdn.shopify.com/s/files/1/0653/3919/files/Bolsa-tela-Harber-London.heic?v=1701255212", shopify_product_id: 999997 });
            this.articulos.push({ sku: "CLOTH-BAG-XL", image: "https://cdn.shopify.com/s/files/1/0653/3919/files/Bolsa-tela-Harber-London.heic?v=1701255212", shopify_product_id: 999996 });

            this.articulos.push({ sku: "otros", image: "", shopify_product_id: -1 });

            this.listadoPendiente = resPendiente;
            




            this.listadoPendiente.forEach(itemPendiente => {           
              itemPendiente.check = false;
              itemPendiente.editando = false;
              const articuloCorrespondiente = this.articulos.find(itemArticulo => itemPendiente.sku === itemArticulo.sku);
              if (articuloCorrespondiente) {
                  itemPendiente.image = articuloCorrespondiente.image;
              }

              let skuCortado = itemPendiente.sku.replace(/-[^-]+$/, "");

              if(itemPendiente.sku.includes('CLOTH-BAG'))
                skuCortado = itemPendiente.sku;

              const articuloEncontrado = this.articulosSku.filter(item => item.sku === skuCortado);


              function calcularTotal(articulo, cantidad) {
                let total;
                if (articulo.confeccion == 0 && articulo.ubrique != 0) {
                  total = articulo.ubrique * cantidad;
                } else {
                  total = articulo.confeccion * cantidad;
                }
                return parseFloat(total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(/\./g, 'temp').replace(/,/g, '.').replace(/temp/g, ',');
              }

              if(articuloEncontrado.length > 0)
              {
                itemPendiente.total = calcularTotal(articuloEncontrado[0], itemPendiente.cantidad);
                itemPendiente.precioUnidad = calcularTotal(articuloEncontrado[0], 1);               
              }
              else if (this.tieneSegmentoExtra(skuCortado)) {
                // Doble color (ej: RPET-BRIEFCASE-15-BLK-GRY), NOMAD, DOPP...: quitar otro segmento
                let skuCortadoDoble = skuCortado.replace(/-[^-]+$/, "");

                const articuloEncontradoDoble = this.articulosSku.filter(item => item.sku === skuCortadoDoble);
                if (articuloEncontradoDoble.length > 0) {
                  itemPendiente.total = calcularTotal(articuloEncontradoDoble[0], itemPendiente.cantidad);
                  itemPendiente.precioUnidad = calcularTotal(articuloEncontradoDoble[0], 1);
                }
              }

            });

            this.total0 = this.facturar(true, false);
            this.total21 = this.facturar(false, false);

            this.buscarFuncion();
        })
        .catch(error => {
            console.error("Error en las solicitudes axios:", error);
        });

      },
      openModalNew(){
        const now = new Date();
        const day = now.getDate().toString().padStart(2, '0');
        let month = (now.getMonth() + 1).toString().padStart(2, '0');
        const year = now.getFullYear();
        
        this.inputFecha = `${year}-${month}-${day}`;

        this.articulosAddMore = [
          { image: '',
            sku: '',
            cantidad: '',
            fecha: ''
          }
        ];

        this.$bvModal.show('modal-add');

        setTimeout(()=>{
          const elements = document.querySelectorAll('.vs__search');
            elements[elements.length-1].focus();
        }, 100);
      },
      borrarButtonClick(){

        const confirmOptions = {
          showCancelButton: true,
          cancelButtonText: 'No',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        };

        let cantidad = 0;

        this.listadoPendiente.forEach(item => {
          if(item.check)
            cantidad++;
        });


        if(cantidad == 0){
          this.$swal({title: "No hay productos seleccionados."});
        }
        else
        {

          let textoFinal = 'producto?'

          if(cantidad > 1)
            textoFinal = 'productos?'

          this.$swal({
              title: `¿Estas seguro que quieres borrar ${cantidad} ${textoFinal}`,
              icon: 'question',            
              confirmButtonText: 'Si, borrar',
              ...confirmOptions,
            }).then(result => {
              if (result.value) {
                this.deleteProducto();
              }
            });

        }
      },
      deleteLineAddMore(index){
        this.articulosAddMore.splice(index, 1);
      },
      addMore(){
        this.articulosAddMore.push(
          { image: '',
            sku: '',
            cantidad: '',
            fecha: ''
          }
        );

        setTimeout(()=>{
          const elements = document.querySelectorAll('.vs__search');
            elements[elements.length-1].focus();
        }, 100);

      },
      limpiarAdd(){
        this.articulosAddMore = [
          { image: '',
            sku: '',
            cantidad: '',
            fecha: ''
          }
        ];
      },
      guardarPendiente(){

        let datosEnviar = [];

        this.articulosAddMore.forEach(item => {

            let finalizado = false;
            let sku = item.sku.sku;

            if(item.sku.shopify_product_id == -1)
            {
                finalizado = true;
                sku = item.titulo; 
            }

            if(item.sku != '' && item.cantidad != '')
            {
              const today = new Date();
              let fecha = "";
              if(item.fecha == "")
                fecha = today.toISOString().split('T')[0];
              else
                fecha = item.fecha;

              datosEnviar.push( {
                sku: sku,
                cantidad: item.cantidad,
                titulo: sku,
                fechaTerminado: fecha,
                finalizado: finalizado,
                product: item.sku
              })
            }

        });

        this.articulosAddMore = [
          { image: '',
            sku: '',
            cantidad: '',
            fecha: ''
          }];

        axios
          .post("/finanzas/pendiente/multiple/facturar", datosEnviar)
          .then(response => {
              return response.data;
          })
          .then(res => {

            let idNext = res.insertId;

            datosEnviar.forEach(item => {
              item.id = idNext;
              item.check = false;
              item.image = item.product.image;
              item.finalizado = false;

              let skuCortado = item.sku.replace(/-[^-]+$/, "");

              if(item.sku.includes('CLOTH-BAG'))
                skuCortado = item.sku;

              const articuloEncontrado = this.articulosSku.filter(item => item.sku === skuCortado);

              if(articuloEncontrado.length > 0)
              {
                if(articuloEncontrado[0].confeccion == 0 && articuloEncontrado[0].ubrique != 0)
                  item.total = articuloEncontrado[0].ubrique * item.cantidad;
                else
                  item.total = articuloEncontrado[0].confeccion * item.cantidad;

                item.total = parseFloat(item.total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(/\./g, 'temp').replace(/,/g, '.').replace(/temp/g, ',');
              }

              this.listadoPendiente.unshift(item);

              idNext++;
            });

            this.$bvModal.hide('modal-add');

            this.buscarFuncion(this.listadoPendiente);

            this.$swal({
                icon: 'success',
                title: 'Completado',
                text: 'Se han agregado correctamente los productos.',
                customClass: {
                confirmButton: 'btn btn-success',
                },
            })

          });

      },
      guardarPediente(){

        if(this.inputSku != null)
        {
            let finalizado = false;
            let sku = this.inputSku.sku;

            if(this.inputSku.shopify_product_id == -1)
            {
                finalizado = true;
                sku = this.inputTitulo; 
            }

            if(sku == '' || this.inputCantidad == '')
                return;

            let data = {
                sku: sku,
                cantidad: this.inputCantidad,
                titulo: sku,
                fechaTerminado: this.inputFecha,
                finalizado: finalizado
            }

            axios
                .post("/finanzas/pendiente/facturar", data)
                .then(response => {
                    return response.data;
                })
                .then(res => {

                    data.id = res.insertId;
                    data.check = false;
                    data.image = this.inputSku.image;
                    data.finalizado = false;
                    this.listadoPendiente.unshift(data);

                    this.$bvModal.hide('modal-add');

                    this.inputSku = null;
                    this.inputCantidad = "";
                    this.inputTitulo = "";
                    this.inputFecha = "";

                    this.buscarFuncion(this.listadoPendiente);

                    this.$swal({
                        icon: 'success',
                        title: data.sku,
                        text: 'Se ha agregado correctamente.',
                        customClass: {
                        confirmButton: 'btn btn-success',
                        },
                    })
                });
        }
      },
      cargarColumnas()
      {
        this.columnasTable = [];

        this.columnasAll.forEach(column => {
          this.columnasTable.push(column);
        });
      },
      editarPrecios(){
        this.$router.push('/precios-sku');
      },
      tieneSegmentoExtra(skuCortado){
        // Solo se quita un segundo segmento si es un color conocido o un caso especial
        const colores = ['TAN', 'BLACK', 'BLK', 'NAVY', 'NVY', 'BROWN', 'BRN', 'GREY', 'GRY', 'GREEN', 'GRN',
          'BURGUNDY', 'BLUE', 'CAMEL', 'COGNAC', 'WHISKY', 'DB', 'OLIVE', 'MOCHA', 'ARMY', 'CAOBA',
          'RED', 'PINK', 'WHITE', 'AMBER', 'STONE', 'HAB', 'KHK'];
        const ultimo = skuCortado.split('-').pop();
        return colores.includes(ultimo) || ultimo === 'NOMAD' || ultimo === 'DOPP' || skuCortado.includes('CARD-HOLDER-RFID-HOR');
      },
      esSinPrecioExcluido(sku){
        // Productos que no llevan precio de confección
        return (sku || '').includes('GIFT-CARD');
      },
      calcularSkuCortado(sku){
        let skuCortado = sku.replace(/-[^-]+$/, "");
        if(sku.includes('CLOTH-BAG'))
          skuCortado = sku;
        return skuCortado;
      },
      formatearTotal(articulo, cantidad){
        let total;
        if(articulo.confeccion == 0 && articulo.ubrique != 0)
          total = articulo.ubrique * cantidad;
        else
          total = articulo.confeccion * cantidad;
        return parseFloat(total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(/\./g, 'temp').replace(/,/g, '.').replace(/temp/g, ',');
      },
      abrirSinPrecio(){
        const grupos = {};

        this.listadoPendiente.forEach(item => {
          if(item.finalizado)
            return;
          if(item.total !== undefined && item.total !== null && item.total !== '')
            return;
          if(this.esSinPrecioExcluido(item.sku))
            return;

          const skuBase = this.calcularSkuCortado(item.sku);

          if(!grupos[skuBase])
          {
            grupos[skuBase] = {
              skuBase: skuBase,
              image: item.image || '',
              lineas: 0,
              unidades: 0,
              precio: '',
              guardando: false
            };
          }

          grupos[skuBase].lineas += 1;
          grupos[skuBase].unidades += parseFloat(item.cantidad) || 0;
          if(!grupos[skuBase].image && item.image)
            grupos[skuBase].image = item.image;
        });

        this.sinPrecioLista = Object.values(grupos).sort((a, b) => b.unidades - a.unidades);

        this.$bvModal.show('modal-sin-precio');
      },
      aplicarPrecioPendientes(skuBase){
        const articulo = this.articulosSku.find(a => a.sku === skuBase);
        if(!articulo)
          return;

        this.listadoPendiente.forEach(item => {
          if(item.finalizado)
            return;
          if(this.calcularSkuCortado(item.sku) !== skuBase)
            return;

          this.$set(item, 'total', this.formatearTotal(articulo, item.cantidad));
          this.$set(item, 'precioUnidad', this.formatearTotal(articulo, 1));
        });
      },
      abrirFormPrecio(grupo){
        this.spGrupoActual = grupo;

        this.spNombre = grupo.skuBase;
        this.spSku = grupo.skuBase;
        this.spConfeccion = 0;
        this.spUbrique = 0;
        this.spMateriales = 0;
        this.spPackaging = 0;
        this.spShipping = 0;
        this.spRrp = 0;
        this.spRrpE = 0;
        this.spRoas = 0;
        this.spHsCode = '';
        this.spTotal = 0;
        this.spMultiplicador = 0.155;
        this.spExchange = this.exchangeLibraEuro;
        this.spAutoManual = false;
        this.spVariantSearch = 'outline-primary';

        this.$bvModal.show('modal-precio-form');

        // Intentar autocompletar el precio £ desde Shopify
        this.$nextTick(() => this.buscarSkuPrecio());
      },
      buscarSkuPrecio(){
        let precioEncontrado = null;

        this.listadoProductos.some(producto => {
          const varianteEncontrada = producto.variants.find(variante => variante.sku && variante.sku.includes(this.spSku));
          if(varianteEncontrada){
            precioEncontrado = varianteEncontrada.price;
            return true;
          }
          return false;
        });

        if(precioEncontrado !== null){
          this.spVariantSearch = 'outline-success';
          this.spRrp = precioEncontrado;
          this.spCalcular();
        } else {
          this.spVariantSearch = 'outline-danger';
        }
      },
      spCalcular(){
        let precioConfe = 0;

        if(!this.spAutoManual)
          this.spConfeccion = (parseFloat(this.spRrpE) * parseFloat(this.spMultiplicador)).toFixed(2);

        if(parseFloat(this.spConfeccion) > 0)
          precioConfe = parseFloat(this.spConfeccion);
        else
          precioConfe = parseFloat(this.spUbrique);

        this.spTotal = (precioConfe + parseFloat(this.spMateriales)).toFixed(2);
        this.spRoas = parseFloat(((parseFloat(this.spRrpE) - (parseFloat(this.spTotal) + parseFloat(this.spPackaging) + parseFloat(this.spShipping))) / parseFloat(this.spRrpE)) * 100).toFixed(2);

        if(isNaN(this.spRoas))
          this.spRoas = 0;
      },
      guardarPrecioForm(){
        let error = false;

        if(String(this.spSku).length < 2){
          this.$bvToast.toast(`El sku no puede estar vacio.`, { title: 'Faltan datos', variant: 'danger', solid: true });
          error = true;
        }

        if(parseFloat(this.spConfeccion) <= 0 && parseFloat(this.spUbrique) <= 0){
          this.$bvToast.toast(`Debes indicar un precio de confeccion o ubrique.`, { title: 'Faltan datos', variant: 'danger', solid: true });
          error = true;
        }

        const skuExiste = this.articulosSku.find(item => item.sku === this.spSku);
        if(skuExiste){
          this.$bvToast.toast(`El sku ya existe.`, { title: 'Error', variant: 'danger', solid: true });
          error = true;
        }

        if(error)
          return;

        this.spGuardando = true;

        const data = {
          nombre: this.spNombre,
          sku: this.spSku,
          confeccion: this.spConfeccion,
          ubrique: this.spUbrique,
          materiales: this.spMateriales,
          packaging: this.spPackaging,
          shipping: this.spShipping,
          rrp: this.spRrp,
          roas: this.spRoas,
          hsCode: this.spHsCode,
          rrpE: this.spRrpE,
          total: this.spTotal,
          multiplicador: this.spAutoManual ? -1 : this.spMultiplicador,
          exchange: this.spExchange
        };

        axios
          .post("/finanzas/articulo/precio", data)
          .then(response => response.data)
          .then(res => {

            data.id = res.insertId;
            this.articulosSku.push(data);

            this.aplicarPrecioPendientes(this.spSku);

            if(this.spGrupoActual)
              this.sinPrecioLista = this.sinPrecioLista.filter(g => g.skuBase !== this.spGrupoActual.skuBase);

            this.buscarFuncion();
            this.total0 = this.facturar(true, false);
            this.total21 = this.facturar(false, false);

            this.spGuardando = false;
            this.$bvModal.hide('modal-precio-form');

            this.$swal({
              icon: 'success',
              title: this.spSku,
              text: 'Precio agregado correctamente.',
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2500,
              timerProgressBar: true
            });
          })
          .catch(error => {
            this.spGuardando = false;
            console.error("Error al guardar precio:", error);
            this.$swal({ icon: 'error', title: 'Error', text: 'No se pudo guardar el precio.' });
          });
      },
      selectAll(){
        //this.listadoPendiente
        this.articulosBusqueda.forEach(element => {
          element.check = true;
        });
        this.$refs.table.refresh();
      },
      copiarSelect(){

        var csv = "SKU;Fecha;Cantidad;Precio\n";

        this.articulosBusqueda.forEach(item => {
          let totalItem = "";

          if(item.total != undefined)
            totalItem = item.total;

          csv += item.sku + ";" + item.fechaTerminado + ";" + item.cantidad + ";" + totalItem + "\n";
        });

        navigator.clipboard.writeText(csv);

        this.$swal({
                  icon: 'success',
                  title: 'Productos copiados.',
                  text: '',
                  customClass: {
                  confirmButton: 'btn btn-success',
                  },
              });
          

        /*var encodedUri = encodeURI(csv);
        var link = document.createElement("a");
        link.setAttribute("href", 'data:text/csv;charset=utf-8,'+encodedUri);
        link.setAttribute("download", "sku_precios.csv");
        document.body.appendChild(link); 
        link.click();*/
      },
      editandoCantidad(data){
        data.editando = true;
        this.$refs.table.refresh();
      },
      guardarCantidad(data){
        data.editando = false;
        this.$refs.table.refresh();

        axios
          .put("/finanzas/pendiente/facturar", data)
          .then(response => {
              return response.data;
          })
          .then(res => {

              this.$swal({
                  icon: 'success',
                  title: data.sku,
                  text: 'Se ha modificado la cantidad correctamente.',
                  customClass: {
                  confirmButton: 'btn btn-success',
                  },
              })
          });

      },
      getStockProduccion(item){
        let aux = item.prevision - item.stock;
        if(aux <= 0)
            aux = "";
        return aux;
      },
      loadMore() {
        this.countItemView += this.nextScrollItemView;
        this.buscarFuncion();
      },
      togglePicker(data)
      {
        this.itemSelect = data.item;
      },
      rowClick(data)
      {
        this.itemSelect = data;
      },
      sortChanged(e) {
        this.lastSort = e;
        this.buscarFuncion();
      },
      facturarProductos(){
        let ids = [];

        this.listadoPendiente.forEach( item => {
          if(item.check)
            ids.push(item);
        });

          this.$router.push({ name: 'factura-edit', params: { parametro: ids } });
      },
      pedirCodigo(){
          this.$swal({
                    title: 'Introducir codigo.',
                    input: 'text',

                    showCloseButton: true,       
                    inputValidator: (value) => {
                      
                      if (!value) {                        
                      }
                      else{
                        this.facturarProductosManual(value);
                      }
                    }
                })

      },
      facturarProductosManual(codigo){
        let ids = [];

        this.listadoPendiente.forEach( item => {
          if(item.check){
            item.factura = codigo;
            item.fecha = '';
            item.finalizado = 1;
            ids.push(item);
          }
            
        });

        axios
          .post("/finanzas/pendiente/finalizar", ids)
          .then(response => {
            return response.data;
          })
          .then(res => {
              this.buscarFuncion();
            });  

        //let datos = {factura: codigo, fecha:'', lista: ids};

      },
      itemCheck(){

        setTimeout(() => {
            this.calcularPrecios();
          }, 100);

      },
      calcularPrecios(){
        let contador = 0;
        let total = 0;

        this.listadoPendiente.forEach(articulo => {
          if(articulo.check)
          {
            contador++;

            let skuCortado = articulo.sku.replace(/-[^-]+$/, "");

            if(articulo.sku.includes('CLOTH-BAG'))
              skuCortado = articulo.sku;

            const articuloEncontrado = this.articulosSku.filter(item => item.sku === skuCortado);

            if(articuloEncontrado.length > 0)
            {
              total+= articuloEncontrado[0].confeccion * articulo.cantidad;
            }
            else{
              if ((skuCortado.split('-').pop() == 'NOMAD') || (skuCortado.split('-').pop() == 'DOPP')) 
              {
                let skuCortadoNomadDop = skuCortado.replace(/-[^-]+$/, "");

                const articuloEncontradoNomad = this.articulosSku.filter(item => item.sku === skuCortadoNomadDop);
                if (articuloEncontradoNomad.length > 0) {
                  total += articuloEncontradoNomad[0].confeccion * articulo.cantidad;
                }
                
              }
            }
          }

        });

        this.cantidadCheck = contador;
        this.totalCheck = parseFloat(total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(/\./g, 'temp').replace(/,/g, '.').replace(/temp/g, ',');
        //this.totalCheck = total;

      },
      deleteProducto(){

        let ids = [];

        this.listadoPendiente.forEach( item => {
          if(item.check)
            ids.push(item.id);
        });

        axios
            .delete("/finanzas/pendiente/facturar",{data: ids})
            .then(response => {
                return response.data;
            })
            .then(res => {

               this.listadoPendiente = this.listadoPendiente.filter(elemento => !ids.includes(elemento.id));

               this.articulosBusqueda = this.articulosBusqueda.filter(elemento => !ids.includes(elemento.id));

              this.buscarFuncion();
            });
      },
      buscarFuncion(items = this.listadoPendiente ){
        //let auxSorting = JSON.parse(JSON.stringify(items));
        let auxSorting = items;        

        if(this.lastSort != null)
        {
          if(this.lastSort.sortDesc)
            auxSorting.sort((a,b) => b[this.lastSort.sortBy] - a[this.lastSort.sortBy]);
          else
            auxSorting.sort((a,b) => a[this.lastSort.sortBy] - b[this.lastSort.sortBy]);

          if(this.lastSort.sortBy == "sku")
          {
            if(this.lastSort.sortDesc)
              auxSorting.sort((a, b) => b.sku.localeCompare(a.sku))
            else
              auxSorting.sort((a, b) => a.sku.localeCompare(b.sku))
          }

        }

        items = auxSorting;

        if(!this.agruparCheck)
        {
          if (!this.pedienteCheck) 
            items = items.filter(item => !item.finalizado);
          else
            items = items.filter(item => item.finalizado);
        }

        if(this.anyoSelect.value != "Todos")
        {
          items = items.filter(item => item.fechaTerminado.includes(this.anyoSelect.value));
        }

        items = items.filter(item => {

          const fechaDesdeCondicion = !this.fechaDesdeSelect || new Date(item.fechaTerminado) >= new Date(this.fechaDesdeSelect);
          const fechaHastaCondicion = !this.fechaHastaSelect || new Date(item.fechaTerminado) <= new Date(this.fechaHastaSelect);

          return fechaDesdeCondicion && fechaHastaCondicion;

        });

        this.articulosBusqueda = [];

        if(this.buscar == "")
        {
            this.articulosBusqueda = items;
        }
        else
        {
          let articulosEncontrado = [];
          items.forEach(articulo => {
            if(articulo.sku.toLowerCase().includes(this.buscar.toLowerCase()))
            {
                articulosEncontrado.push(articulo);
            }
          });

            this.articulosBusqueda = articulosEncontrado;
        }

        if(this.agruparCheck)
        {          
          let auxArray = JSON.parse(JSON.stringify(this.articulosBusqueda))
                .filter(objeto => objeto.finalizado === 0);

          const arrayAgrupado = auxArray.reduce((resultado, objeto) => {
            // Verificar si ya existe una entrada para ese SKU
            const existeEntrada = resultado.find(item => item.sku === objeto.sku);

            if (existeEntrada && existeEntrada.finalizado == 0) {
              // Convertir cantidad y total a números si son válidos
              const cantidad = parseFloat(objeto.cantidad);
              const total = parseFloat(objeto.total);

              // Si la cantidad es válida, sumarla
              if (!isNaN(cantidad)) {
                existeEntrada.cantidad += cantidad;
              }

              // Si el total es válido, sumarlo
              if (!isNaN(total)) {
                existeEntrada.total = parseFloat(existeEntrada.total) + total;
              }

              // Si el total es NaN, establecerlo como vacío o algún valor por defecto
              if (isNaN(existeEntrada.total)) {
                existeEntrada.total = '';
              }
            } else {
              // Si no existe, agregar una nueva entrada
              resultado.push({
                ...objeto,
                cantidad: parseFloat(objeto.cantidad) || 0, // Validar cantidad al agregar
                total: parseFloat(objeto.total) || 0 // Validar total al agregar
              });
            }

            return resultado;
          }, []);

          this.articulosBusqueda = arrayAgrupado;

        }

        //agruparCheck
      },
      recalcularDatos()
      {
        this.cargarColumnas();

        this.buscarFuncion();
      },
      seleccionarTodos(){

        this.articulosBusqueda.forEach(item => {
          item.check = true;
        });

        this.calcularPrecios();

        this.$refs.table.refresh();

      },
      limpiarSeleccionados(){

        this.articulosBusqueda.forEach(item => {
          item.check = false;
        });

        this.calcularPrecios();

        this.$refs.table.refresh();
      },
      facturar(noImp = false, crearFactura = true){        

        this.to21 = noImp;
        this.pendientesParaFacturar = [];

        let total = 0;
        let totalArticulos = 0;

        let pendientes = this.listadoPendiente
        .slice() 
        .reverse()
        .filter(item => item.finalizado == 0)
        .map(item => ({ ...item }));

          this.ordersDate.forEach(order => {
            if (!this.to21 === (order.full_data.address.country_code === "ES")) {
              if(this.listadoTrackingsUsados.find(o => o.tracking === order.tracking))
                return;
              order.full_data.declarations.forEach(declaration => {
                const pendiente = pendientes.find(p => p.sku === declaration.sku && p.cantidad > 0);                

                if (pendiente) {
                  const cantidadParaUsar = Math.min(pendiente.cantidad, declaration.quantity);                  

                  if (cantidadParaUsar > 0) {
                    this.pendientesParaFacturar.push({
                      sku: pendiente.sku,
                      cantidad: cantidadParaUsar,
                      order: order.order_num,
                      tracking: order.tracking,
                      fecha: order.confirmation_date,
                      idAlbaran: pendiente.id,
                      company_tracking: order.company_name || '',
                      country_sent: order.full_data.address.country_code || '',
                    });


                    pendiente.cantidad -= cantidadParaUsar;
                    pendiente.actualizar = true;

                    pendiente.cantidadFacturada += cantidadParaUsar;
                    //const precio = Number.parseFloat(pendiente?.precioUnidad) || 0;
                    //const precio = parseFloat((pendiente?.precioUnidad || '').replace(',', '.')) || 0;
                    const precio = parseFloat(
                      (pendiente?.precioUnidad || '')
                        .replace(/\./g, '')
                        .replace(',', '.') 
                    ) || 0;
                    const cantidad = Number(cantidadParaUsar) || 0;
                    total += precio * cantidad;
                    //total += parseFloat(pendiente.precioUnidad) * (cantidadParaUsar);
                    totalArticulos += cantidadParaUsar;
                      

                    if(pendiente.cantidad == 0)
                      pendiente.finalizado = 1;
                  }
                }
              });
            }
          });


          if(crearFactura)
            this.$router.push({ name: 'factura-edit', params: { parametro: this.pendientesParaFacturar, iva21: this.to21, facturaAlbaran: true, pendientes: pendientes.filter(item=> item.actualizar) } });
          else{
            return totalArticulos + ' articulos ' + total.toFixed(0) + '€';
          }

      },
    },
     mounted() {
      this.loadItems();
    },    
    watch: {
      buscar(){
        if(this.buscar == "")
          this.countItemView = this.defaultItemView;
        this.buscarFuncion();
      },
      agruparCheck(){
        this.buscarFuncion();
      },
      meses: {
        handler(newValue, oldValue) {
          if(this.watching)
            this.recalcularDatos();
        },
        deep: true
      },
      anyos: {
        handler(newValue, oldValue) {
          if(this.watching)
            this.recalcularDatos();
        },
        deep: true
      },
      listadoPendiente: {
        handler(newValue, oldValue) {
            this.calcularPrecios();
        },
        deep: true
      },
      empresaSelect(){
        this.countItemView = this.defaultItemView;
        //this.recalcularDatos();
      },
      anyoSelect(){
        this.countItemView = this.defaultItemView;
         this.buscarFuncion();
      },
      pedienteCheck(){
        this.buscarFuncion();
      },
      fechaDesdeSelect(){
        this.buscarFuncion();
      },
      fechaHastaSelect(){
        this.buscarFuncion();
      },
      dateRange(){
        const start = new Date(this.dateRange.startDate);
        start.setHours(0, 0, 0, 0); // 00:00:00.000

        const end = new Date(this.dateRange.endDate);
        end.setHours(23, 59, 59, 999); // 23:59:59.999

        const requestTrackings = axios.get("/finanzas/tracking/dates", {
            params: {
              fechaInicio: start.toISOString(),
              fechaFin: end.toISOString()
            }
        }).then(response => response.data);


        Promise.all([ requestTrackings])
        .then(([resTracking]) => {     

          this.ordersDate = resTracking;

          this.total0 = this.facturar(true, false);
          this.total21 = this.facturar(false, false);

        });

      },
      spTotal(){ this.spCalcular(); },
      spRrpE(){ this.spCalcular(); },
      spRrp(){ this.spRrpE = parseFloat(this.spRrp * this.spExchange).toFixed(2); },
      exchangeLibraEuro(){
        this.spRrpE = parseFloat(this.spRrp * this.spExchange).toFixed(2);
        this.spCalcular();
      },
      spMultiplicador(){ this.spCalcular(); },
      spConfeccion(){ this.spCalcular(); },
      spMateriales(){ this.spCalcular(); },
      spPackaging(){ this.spCalcular(); },
      spShipping(){ this.spCalcular(); },
      spUbrique(){ this.spCalcular(); },
      spAutoManual(){
        if(this.spAutoManual)
          this.spExchange = this.exchangeLibraEuro;
      },
      spExchange(){
        this.spRrpE = parseFloat(this.spRrp * this.spExchange).toFixed(2);
        this.spCalcular();
      }
    }
  }
</script>

<style lang="scss">
@import '../@core/scss/vue/libs/chart-apex.scss';
@import '../@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>

<style scoped>
/* ═══ Layout ═══ */
.alb2 { padding: 0; }

.alb2__main {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* ═══ Toolbar ═══ */
.alb2__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-radius: 14px;
  padding: 14px 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.alb2__toolbar-left,
.alb2__toolbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.alb2__toolbar-title {
  font-size: 16px;
  font-weight: 700;
  color: #3b4253;
  display: flex;
  align-items: center;
  gap: 8px;
}
.alb2__toolbar-title i { color: #7367f0; }

/* ═══ Botones ═══ */
.alb2__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 10px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.alb2__btn--primary { background: #7367f0; color: #fff; }
.alb2__btn--primary:hover { background: #5e50ee; box-shadow: 0 4px 12px rgba(115, 103, 240, 0.35); }

.alb2__btn--secondary { background: #f4f5f7; color: #5e5873; }
.alb2__btn--secondary:hover { background: #e8e6f0; }

.alb2__btn--success { background: #28c76f; color: #fff; }
.alb2__btn--success:hover { background: #1fa85c; box-shadow: 0 4px 12px rgba(40, 199, 111, 0.35); }

.alb2__btn--danger-outline { background: transparent; color: #ea5455; border: 1px solid #ea5455; }
.alb2__btn--danger-outline:hover { background: #ea5455; color: #fff; }

.alb2__btn--outline { background: transparent; color: #7367f0; border: 1px solid #7367f0; }
.alb2__btn--outline:hover { background: #7367f0; color: #fff; }

.alb2__btn--warning { background: transparent; color: #ff9f43; border: 1px solid #ff9f43; }
.alb2__btn--warning:hover { background: #ff9f43; color: #fff; }
.alb2__btn:disabled { opacity: 0.55; cursor: not-allowed; }

.alb2__count-badge {
  display: inline-flex; align-items: center; justify-content: center;
  min-width: 20px; height: 20px; padding: 0 6px; margin-left: 2px;
  background: #ea5455; color: #fff; border-radius: 20px;
  font-size: 11px; font-weight: 700; line-height: 1;
}

/* ═══ Modal sin precio ═══ */
.alb2__sp-hint {
  font-size: 13px; color: #6e6b7b; margin-bottom: 16px;
  background: #fff8ee; border: 1px solid #ffe2bf; border-radius: 10px; padding: 10px 14px;
}

.alb2__sp-empty {
  text-align: center; padding: 30px 10px; color: #28c76f;
}
.alb2__sp-empty i { font-size: 42px; margin-bottom: 10px; }
.alb2__sp-empty p { color: #5e5873; font-size: 14px; margin: 0; }

.alb2__sp-row {
  display: flex; align-items: center; gap: 14px;
  padding: 12px; border: 1px solid #f0f1f4; border-radius: 12px; margin-bottom: 10px;
}
.alb2__sp-row:hover { background: #f9f8ff; }

.alb2__sp-noimg {
  width: 80px; height: 80px; border-radius: 8px; border: 1px dashed #d8dade;
  display: flex; align-items: center; justify-content: center; color: #b0b5c0; font-size: 24px;
  flex-shrink: 0;
}

.alb2__sp-info { flex: 1; min-width: 0; }
.alb2__sp-sku { font-weight: 700; color: #5e5873; word-break: break-all; }
.alb2__sp-meta { font-size: 12px; color: #a0a4ad; margin-top: 2px; }

.alb2__btn-fab {
  width: 42px; height: 42px; border-radius: 50%; border: none;
  background: linear-gradient(135deg, #28c76f 0%, #48da89 100%);
  color: #fff; font-size: 18px; cursor: pointer;
  box-shadow: 0 4px 14px rgba(40, 199, 111, 0.4);
  transition: all 0.2s;
  display: flex; align-items: center; justify-content: center;
}
.alb2__btn-fab:hover { transform: scale(1.1); box-shadow: 0 6px 20px rgba(40, 199, 111, 0.5); }

.alb2__btn-icon {
  width: 34px; height: 34px; border-radius: 10px; border: none;
  cursor: pointer; display: flex; align-items: center; justify-content: center;
  font-size: 14px; transition: all 0.2s;
}
.alb2__btn-icon--danger { background: #fce4e4; color: #ea5455; }
.alb2__btn-icon--danger:hover { background: #ea5455; color: #fff; }

/* ═══ Calendario + Facturar ═══ */
.alb2__calendar-section {
  background: #fff;
  border-radius: 14px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.alb2__calendar-wrap {
  border-radius: 12px;
  overflow: hidden;
}

.alb2__facturar-btn {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 18px 24px;
  border-radius: 14px;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;
  width: 100%;
}

.alb2__facturar-btn--0 {
  background: linear-gradient(135deg, #7367f0 0%, #9b8cf8 100%);
  color: #fff;
}
.alb2__facturar-btn--0:hover {
  box-shadow: 0 6px 20px rgba(115, 103, 240, 0.4);
  transform: translateY(-2px);
}

.alb2__facturar-btn--21 {
  background: linear-gradient(135deg, #28c76f 0%, #48da89 100%);
  color: #fff;
}
.alb2__facturar-btn--21:hover {
  box-shadow: 0 6px 20px rgba(40, 199, 111, 0.4);
  transform: translateY(-2px);
}

.alb2__facturar-main {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 700;
}
.alb2__facturar-main i { font-size: 20px; }

.alb2__facturar-meta {
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 13px;
  opacity: 0.9;
}

.alb2__facturar-date {
  display: flex;
  align-items: center;
  gap: 5px;
}

.alb2__facturar-total {
  background: rgba(255, 255, 255, 0.25);
  padding: 2px 10px;
  border-radius: 20px;
  font-weight: 600;
}

/* ═══ Buscador ═══ */
.alb2__search { position: relative; }

.alb2__search-icon {
  position: absolute; left: 16px; top: 50%; transform: translateY(-50%);
  color: #b0b5c0; font-size: 14px; z-index: 1;
}

.alb2__search-input {
  width: 100%; padding: 12px 16px 12px 42px;
  border: 1px solid #e9ecf1; border-radius: 14px;
  font-size: 14px; color: #3b4253; background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.2s; outline: none;
}
.alb2__search-input:focus { border-color: #7367f0; box-shadow: 0 0 0 3px rgba(115, 103, 240, 0.12); }
.alb2__search-input::placeholder { color: #c0c4cc; }

/* ═══ Tabla ═══ */
.alb2__table-card {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.alb2__sku {
  color: #7367f0; font-weight: 600; cursor: pointer; transition: color 0.15s;
}
.alb2__sku:hover { color: #5e50ee; text-decoration: underline; }

.alb2__img {
  width: 44px; height: 44px; object-fit: cover; border-radius: 8px; border: 1px solid #eee;
}
.alb2__img--lg { width: 80px; height: 80px; }

.alb2__cantidad {
  display: inline-flex; align-items: center; justify-content: center;
  min-width: 36px; padding: 4px 10px; background: #f4f5f7;
  border-radius: 8px; font-weight: 600; cursor: pointer; transition: all 0.15s; margin: 0;
}
.alb2__cantidad:hover { background: #eeedfd; color: #7367f0; }

.alb2__cantidad-edit { display: flex; align-items: center; gap: 6px; }
.alb2__cantidad-input {
  width: 50px; padding: 4px 8px; border: 1px solid #7367f0;
  border-radius: 8px; text-align: center; font-size: 13px; outline: none;
}
.alb2__cantidad-save {
  background: #28c76f; color: #fff; border: none; border-radius: 8px;
  width: 30px; height: 30px; cursor: pointer;
  display: flex; align-items: center; justify-content: center; transition: all 0.15s;
}
.alb2__cantidad-save:hover { background: #1fa85c; }

.alb2__badge {
  display: inline-block; padding: 3px 10px; border-radius: 20px; font-size: 12px; font-weight: 600;
}
.alb2__badge--facturado { background: #e8fce8; color: #28a745; }
.alb2__badge--pendiente { background: #fff3e0; color: #ff9f43; }

/* ═══ Footer / actions ═══ */
.alb2__add-actions { text-align: center; padding: 14px; }
.alb2__add-footer { text-align: center; padding: 16px; border-top: 1px solid #f0f1f4; }
.alb2__bottom-bar { display: flex; justify-content: center; gap: 12px; padding: 8px 0; }
</style>

<style lang="scss">
/* Estilos globales para tabla y modal alb2 */
.alb2__table {
  margin-bottom: 0;

  thead th {
    background: #f8f9fb !important;
    border-bottom: 2px solid #e9ecf1 !important;
    border-top: none !important;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #8a8e99;
    padding: 12px 14px;
    white-space: nowrap;
  }

  tbody td {
    padding: 10px 14px;
    vertical-align: middle;
    border-bottom: 1px solid #f0f1f4 !important;
    border-top: none !important;
    font-size: 13px;
    color: #5e5873;
  }

  tbody tr {
    transition: background 0.15s;
    background: transparent !important;

    &:hover {
      background: #f9f8ff !important;
    }
  }

  &.b-table-striped tbody tr:nth-of-type(odd) {
    background: transparent !important;
  }
}

.alb2__modal .modal-content {
  border-radius: 16px;
  border: none;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.12);
}

.alb2__modal .modal-header {
  border-bottom: 1px solid #f0f1f4;
  padding: 16px 20px;
}

.alb2__modal .modal-title {
  font-weight: 700;
  color: #3b4253;
}

.alb2__modal .modal-body {
  padding: 20px;
}

.alb2__datepicker {
  width: 100%;
}

.dark-layout {
  .alb2__toolbar,
  .alb2__calendar-section,
  .alb2__table-card,
  .alb2__search-input {
    background: #283046;
  }

  .alb2__search-input {
    border-color: #3b4253;
    color: #d0d2d6;
  }

  .alb2__btn--secondary {
    background: #3b4253;
    color: #d0d2d6;
  }

  .alb2__table {
    thead th {
      background: #343d55 !important;
      color: #b4b7bd;
    }

    tbody td {
      color: #d0d2d6;
      border-bottom-color: #3b4253 !important;
    }

    tbody tr:hover {
      background: #2c3452 !important;
    }
  }
}
</style>